var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon015(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.75;}\n\t.st1{fill:#E39F24;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,15c0-7.7-6.3-14-14-14S1,7.3,1,15s6.3,14,14,14S29,22.7,29,15L29,15z M2.3,15C2.3,8,8,2.3,15,2.3 S27.7,8,27.7,15S22,27.7,15,27.7S2.3,22,2.3,15L2.3,15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,21.8h-6.5c-2,0-3.5-1.6-3.5-3.5v-6.5c0-2,1.6-3.5,3.5-3.5h6.5c2,0,3.5,1.6,3.5,3.5v6.5 C21.5,20.2,19.9,21.8,17.9,21.8L17.9,21.8z M11.4,9.2c-1.4,0-2.6,1.2-2.6,2.6v6.5c0,1.4,1.2,2.6,2.6,2.6h6.5 c1.4,0,2.6-1.2,2.6-2.6v-6.5c0-1.4-1.2-2.6-2.6-2.6C17.9,9.2,11.4,9.2,11.4,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,18.9c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S16.8,18.9,14.7,18.9L14.7,18.9z  M14.7,12.1c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S16.3,12.1,14.7,12.1L14.7,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,10.9c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7C18.7,10.1,19,10.5,19,10.9L19,10.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon015);
export default __webpack_public_path__ + "static/media/icon015.38cb4c8a5402a56a9614c9c60560b138.svg";
export { ForwardRef as ReactComponent };